/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export interface DamIntegrationsPublic {
  integrations: Array<DamIntegrationPublic>;
}

export enum DamIntegrationType {
  'Bynder' = 'Bynder',
}

export type DamIntegrationPublic = DamIntegrationPublicBynder;

export interface DamIntegrationPublicBase {
  enabled: boolean;
  name: string;
  type: DamIntegrationType;
  uuid: string;
}

export interface DamIntegrationPublicBynder extends DamIntegrationPublicBase {
  authUrl: string;
  clientId: string;
  scope: string;
  serviceUrl: string;
  type: DamIntegrationType.Bynder;
}
